import { combineReducers } from 'redux'

import { reducer as addRegionalProject } from './addRegionalProject'
import { reducer as editRegionalProject } from './editRegionalProject'
import { reducer as deleteRegionalProject } from './deleteRegionalProject'
import { reducer as getRegionalProject } from './getRegionalProject'
import { reducer as getRegionalProjectId } from './getRegionalProjectId'

export default combineReducers({
    addRegionalProject,
    editRegionalProject,
    deleteRegionalProject,
    getRegionalProject,
    getRegionalProjectId,
})
